export { CommonLayoutComponent } from './common-layout.component';
